"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var pulseAnimation = function pulseAnimation(props) {
  return (0, _styledComponents.keyframes)(["0%{transform:scale(0.1);", "}50%{transform:scale(1.2);", "}100%{transform:scale(1.2);", "}"], props.customStartState, props.customMiddleState, props.customEndState);
};

var _default = _styledComponents.default.div.withConfig({
  displayName: "pulse",
  componentId: "sc-3jprsz-0"
})(["border-radius:50%;height:", ";width:", ";position:absolute;transform:scale(0.1);animation:", " ", ";transition:box-shadow 200ms ease;animation-delay:", "ms;box-shadow:inset 0 0 5em ", ";"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, pulseAnimation, function (props) {
  return props.animation;
}, function (_ref) {
  var delay = _ref.delay;
  return delay;
}, function (props) {
  return props.shadow;
});

exports.default = _default;